const API_BASE_URL = "https://reward-games.rejuvinitals.com";

const TIERS_DISPLAY = [
  { threshold: 30, pool: ["Rhino 250ml", "REFRESH Hand Wash (Floral)", "REFRESH Hand Wash (Lavender)", "REFRESH Hand Wash (Lemon)"] },
  { threshold: 80, pool: ["Power Wash", "GLIM Glass & Household Cleaner", "Power Wash Dish Wash", "Fabrito Fabric Softener"] },
  { threshold: 120, pool: ["Brighten Laundry Detergent", "Washout Disinfectant (Floral Red)", "Washout Disinfectant (Lemon Yellow)", "Washout Disinfectant (Ocean Blue)"] }
];

let MAX_PLAYS_PER_WINDOW = 3;
let COOLDOWN_MS = 30 * 60 * 1000;
let WIN_POINTS = 10;
let COOLDOWN_HOURS = 0.5;

const MM_TIME_LIMIT = 30;
const MM_PAIR_COUNT = 6;

const FLAPPY_PIPE_GAP = 160;
const FLAPPY_PIPE_SPEED = 2.5;
const FLAPPY_GRAVITY = 0.4;
const FLAPPY_FLAP_STRENGTH = -7;
const FLAPPY_PIPES_TO_WIN = 15;
const FLAPPY_PIPE_WIDTH = 46;
const FLAPPY_PIPE_SPACING = 180;
const FLAPPY_DUCK_SIZE = 28;

const SNAKE_GRID_SIZE = 12;
const SNAKE_TICK_MS = 180;
const SNAKE_TARGET_SCORE = 30;
const SNAKE_TIME_LIMIT_SEC = 45;
const SNAKE_BONUS_FOOD_CHANCE = 0.15;
const SNAKE_BONUS_FOOD_LIFESPAN_SEC = 4;

const WHACK_GRID_SIZE = 9;
const WHACK_TARGET_HITS = 15;
const WHACK_TIME_LIMIT_SEC = 20;
const WHACK_SPOT_VISIBLE_MS = 700;
const WHACK_SPAWN_INTERVAL_MS = 550;
const WHACK_DOUBLE_SPAWN_CHANCE = 0.12;

const MM_PRODUCT_POOL = [
  { label: "Rhino 250ml", emoji: "🦏" },
  { label: "Rhino 500ml", emoji: "🦏" },
  { label: "Rhino 750ml", emoji: "🦏" },
  { label: "Refresh Floral", emoji: "🌸" },
  { label: "Refresh Lavender", emoji: "💜" },
  { label: "Refresh Lemon", emoji: "🍋" },
  { label: "Refresh 5L", emoji: "🧴" },
  { label: "Refresh 60ml", emoji: "🧴" },
  { label: "Power Wash", emoji: "💧" },
  { label: "Power Dish", emoji: "🍽️" },
  { label: "GLIM Cleaner", emoji: "✨" },
  { label: "Fabrito Soft", emoji: "👕" },
  { label: "Brighten Detergent", emoji: "🫧" },
  { label: "Washout Floral", emoji: "🌺" },
  { label: "Washout Lemon", emoji: "🍋" },
  { label: "Washout Ocean", emoji: "🌊" },
  { label: "Degrease Spray", emoji: "🧽" },
  { label: "Titan Stain", emoji: "💪" },
  { label: "Multi Surface", emoji: "🏠" },
  { label: "Hand Sanitizer", emoji: "🧼" },
  { label: "Floor Cleaner", emoji: "🪣" },
  { label: "Glass Shine", emoji: "🪟" },
  { label: "Fabric Fresh", emoji: "🌿" },
  { label: "Kitchen Pro", emoji: "🍳" },
  { label: "Bathroom Plus", emoji: "🛁" },
  { label: "Laundry Boost", emoji: "📦" },
  { label: "Eco Wash", emoji: "♻️" },
  { label: "Citrus Clean", emoji: "🍊" },
  { label: "Herbal Fresh", emoji: "🌱" },
  { label: "Deep Clean", emoji: "⭐" }
];

let state = {
  screen: "rules",
  email: "",
  phone: "",
  otp: "",
  record: null,
  currentGame: null,
  board: Array(9).fill(null),
  turn: "player",
  over: false,
  resultMsg: "",
  errorMsg: "",
  pendingTier: null,
  pendingTierPool: null,
  pendingTierItems: null,
  decisionMode: null, // null | "pick"
  redeemResult: null,
  wheelPrizes: null,
  wheelResult: null,
  wheelSpinning: false,
  mm: null,
  flappy: null,
  snake: null,
  whack: null
};

const app = document.getElementById("app");

function normEmail(e) { return e.trim().toLowerCase(); }
function normPhone(p) { return p.replace(/[^0-9]/g, ""); }

function shuffle(arr) {
  const copy = arr.slice();
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

function pickRandomProducts(count) {
  return shuffle(MM_PRODUCT_POOL).slice(0, count);
}

function buildMemoryDeck() {
  const picked = pickRandomProducts(MM_PAIR_COUNT);
  const pairs = picked.flatMap((product, idx) => [
    { id: idx * 2, key: idx, product, flipped: false, matched: false },
    { id: idx * 2 + 1, key: idx, product, flipped: false, matched: false }
  ]);
  return shuffle(pairs).map((card, i) => ({ ...card, id: i }));
}

async function loadGameConfig() {
  try {
    const res = await fetch(API_BASE_URL + "/api/config");
    if (!res.ok) return;
    const cfg = await res.json();
    MAX_PLAYS_PER_WINDOW = cfg.max_plays_per_window ?? MAX_PLAYS_PER_WINDOW;
    COOLDOWN_MS = cfg.cooldown_ms ?? COOLDOWN_MS;
    COOLDOWN_HOURS = cfg.cooldown_hours ?? COOLDOWN_HOURS;
    WIN_POINTS = cfg.win_points ?? WIN_POINTS;
  } catch (e) { /* use defaults */ }
}

function cooldownLabel() {
  if (COOLDOWN_HOURS === 1) return "1 hour";
  if (COOLDOWN_HOURS > 1) return `${COOLDOWN_HOURS} hours`;
  return `${Math.round(COOLDOWN_MS / 60000)} minutes`;
}

async function apiPost(path, body) {
  let res;
  try {
    res = await fetch(API_BASE_URL + path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });
  } catch (networkErr) {
    const err = new Error("Could not reach the game server. Check your connection and try again.");
    err.status = 0;
    err.data = { error: err.message };
    throw err;
  }
  let data = {};
  try {
    data = await res.json();
  } catch (_) {
    data = { error: res.ok ? "Unexpected server response." : "Server error. Please try again." };
  }
  if (!res.ok) {
    const err = new Error(data.error || "Request failed");
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

function playsLeftLabel(record) {
  if (MAX_PLAYS_PER_WINDOW > 100) return "∞";
  return String(MAX_PLAYS_PER_WINDOW - (record ? record.plays_used : 0));
}

function parseUtc(iso) {
  if (!iso) return NaN;
  const s = iso.endsWith("Z") ? iso : iso + "Z";
  return new Date(s).getTime();
}

function cooldownEndsAt(record) {
  if (record.cooldown_ends_at) return parseUtc(record.cooldown_ends_at);
  return parseUtc(record.window_start) + COOLDOWN_MS;
}

function isLocked(record) {
  if (!record) return false;
  if (Date.now() >= cooldownEndsAt(record)) return false;
  return record.plays_used >= MAX_PLAYS_PER_WINDOW;
}

function findPendingTier(record) {
  if (!record || record.prize_claimed) return null;
  if (record.reached_tier) return record.reached_tier;
  const decided = record.decided_tiers || [];
  const hit = TIERS_DISPLAY.find(t => record.points >= t.threshold && !decided.includes(t.threshold));
  return hit ? hit.threshold : null;
}

function openPrizeDecision(record, extras = {}) {
  const threshold = extras.reached_tier || findPendingTier(record);
  if (!threshold) return false;
  const tier = TIERS_DISPLAY.find(t => t.threshold === threshold);
  state.pendingTier = threshold;
  state.pendingTierPool = extras.tier_pool || (tier ? tier.pool : []);
  state.pendingTierItems = extras.tier_items || null;
  state.wheelPrizes = extras.wheel_prizes || state.wheelPrizes;
  state.decisionMode = null;
  state.errorMsg = "";
  state.screen = "decision";
  return true;
}

function guardLocked() {
  if (isLocked(state.record)) {
    // Prize choice always beats the play-limit screen
    if (openPrizeDecision(state.record)) {
      render();
      return true;
    }
    state.screen = "locked";
    render();
    return true;
  }
  return false;
}

function stopAllGameLoops() {
  clearInterval(window._mmInterval);
  if (window._mmFlipTimers) {
    window._mmFlipTimers.forEach(clearTimeout);
    window._mmFlipTimers = [];
  }
  if (state.mm) mmUnlockBoard(state.mm);
  if (window._flappyRaf) {
    cancelAnimationFrame(window._flappyRaf);
    window._flappyRaf = 0;
  }
  clearInterval(window._snakeTick);
  clearInterval(window._snakeClock);
  clearInterval(window._whackSpawn);
  clearInterval(window._whackClock);
  if (window._whackHideTimers) window._whackHideTimers.forEach(clearTimeout);
  window._whackHideTimers = [];
  if (window._snakeKeyHandler) {
    window.removeEventListener("keydown", window._snakeKeyHandler);
    window._snakeKeyHandler = null;
  }
}

function handlePlayLimitError(e) {
  if (e.status === 429 || (e.data && e.data.error && e.data.error.toLowerCase().includes("play limit"))) {
    if (e.data && e.data.email) state.record = e.data;
    else if (state.record) {
      state.record.plays_used = MAX_PLAYS_PER_WINDOW;
      state.record.locked = true;
    }
    state.resultMsg = "";
    if (openPrizeDecision(state.record, e.data || {})) {
      render();
      return true;
    }
    state.screen = "locked";
    render();
    return true;
  }
  return false;
}

function timeRemaining(record) {
  const remain = cooldownEndsAt(record) - Date.now();
  if (remain <= 0) return "00:00:00";
  const h = Math.floor(remain / 3600000);
  const m = Math.floor((remain % 3600000) / 60000);
  const s = Math.floor((remain % 60000) / 1000);
  return [h, m, s].map(n => String(n).padStart(2, "0")).join(":");
}

const LINES = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]];

function winner(b) {
  for (const [a, c, d] of LINES) {
    if (b[a] && b[a] === b[c] && b[a] === b[d]) return b[a];
  }
  if (b.every(x => x)) return "draw";
  return null;
}

function minimax(b, isComputer, depth) {
  const w = winner(b);
  if (w === "O") return { score: 10 - depth };
  if (w === "X") return { score: depth - 10 };
  if (w === "draw") return { score: 0 };
  const moves = [];
  for (let i = 0; i < 9; i++) {
    if (!b[i]) {
      const copy = b.slice();
      copy[i] = isComputer ? "O" : "X";
      const result = minimax(copy, !isComputer, depth + 1);
      moves.push({ index: i, score: result.score });
    }
  }
  if (isComputer) moves.sort((a, b2) => b2.score - a.score);
  else moves.sort((a, b2) => a.score - b2.score);
  return { score: moves[0].score, moves };
}

function computerMove(board) {
  const empty = [];
  for (let i = 0; i < 9; i++) if (!board[i]) empty.push(i);
  for (const i of empty) {
    const copy = board.slice(); copy[i] = "O";
    if (winner(copy) === "O") return i;
  }
  for (const i of empty) {
    const copy = board.slice(); copy[i] = "X";
    if (winner(copy) === "X") return i;
  }
  const { moves } = minimax(board, true, 0);
  const bestScore = moves[0].score;
  const decent = moves.filter(m => m.score >= bestScore - 3);
  if (decent.length > 1 && Math.random() < 0.35) {
    return decent[Math.floor(Math.random() * decent.length)].index;
  }
  return moves[0].index;
}

function render() {
  if (state.screen === "rules") return renderRules();
  if (state.screen === "gate") return renderGate();
  if (state.screen === "otp") return renderOtp();
  if (state.screen === "locked") return renderLocked();
  if (state.screen === "claimed") return renderClaimed();
  if (state.screen === "wheel") return renderWheel();
  if (state.screen === "decision") return renderDecision();
  if (state.screen === "hub") return renderHub();
  if (state.screen === "ttt") return renderTTT();
  if (state.screen === "memory") return renderMemory();
  if (state.screen === "flappy") return renderFlappy();
  if (state.screen === "snake") return renderSnake();
  if (state.screen === "whack") return renderWhack();
}

function renderRules() {
  app.innerHTML = `
    <h1>🎮 Rejuvinitals Play & Win</h1>
    <div class="sub">Play fun games, collect points, and unlock one free gift.</div>
    <div class="rules">
      <h2>How it works</h2>
      <ul>
        <li>Choose a game each round — Tic-Tac-Toe, Memory Match, Flappy Duck, Snake, or Zap the Dirt.</li>
        <li>Win a round → earn <b>${WIN_POINTS} points</b>.</li>
        <li><b>30 points</b> → unlock your free gift.</li>
        <li>Then choose <b>one</b> option:
          <ul>
            <li><b>Spin the Wheel</b> — win a surprise gift from the wheel.</li>
            <li><b>Pick a Gift</b> — choose any prize from the list.</li>
          </ul>
        </li>
        <li>You get <b>only one gift</b> — either the wheel result or the prize you pick.</li>
        <li>Or keep playing for bigger prizes at <b>80</b> and <b>120</b> points.</li>
        <li>You must verify a <b>real email</b> with a one-time code before playing.</li>
        ${MAX_PLAYS_PER_WINDOW <= 100
          ? `<li>You get <b>${MAX_PLAYS_PER_WINDOW} plays</b>, then wait <b>${cooldownLabel()}</b> before playing again.</li>`
          : ""}
      </ul>
    </div>
    <button class="btn btn-primary" onclick="goToGate()">Let's Play</button>
  `;
}
window.goToGate = () => { state.screen = "gate"; render(); };

function renderGate() {
  app.innerHTML = `
    <h1>Enter your details</h1>
    <div class="sub">We'll send a one-time code to your email to confirm it's real.</div>
    <label>Email</label>
    <input id="emailInput" type="email" placeholder="you@gmail.com" value="${state.email}">
    <label>Phone Number</label>
    <input id="phoneInput" type="tel" placeholder="03xx-xxxxxxx" value="${state.phone}">
    <div class="err">${state.errorMsg}</div>
    <button class="btn btn-primary" id="startBtn" onclick="submitGate()">Send Verification Code</button>
  `;
}

function renderOtp() {
  app.innerHTML = `
    <h1>Verify your email</h1>
    <div class="sub">Enter the 6-digit code we sent to <b>${state.email}</b>. Check spam if you don't see it.</div>
    <label>Verification Code</label>
    <input id="otpInput" type="text" inputmode="numeric" maxlength="6" placeholder="123456" value="${state.otp || ""}" autocomplete="one-time-code">
    <div class="err">${state.errorMsg}</div>
    <button class="btn btn-primary" id="verifyBtn" onclick="submitOtp()">Verify &amp; Play</button>
    <button class="btn btn-ghost" id="resendBtn" onclick="resendOtp()">Resend Code</button>
    <button class="btn btn-ghost" onclick="backToGate()">Change Email</button>
  `;
  const otpEl = document.getElementById("otpInput");
  if (otpEl) otpEl.focus();
}

window.backToGate = () => {
  state.otp = "";
  state.errorMsg = "";
  state.screen = "gate";
  render();
};

window.submitGate = async () => {
  const email = normEmail(document.getElementById("emailInput").value);
  const phone = normPhone(document.getElementById("phoneInput").value);

  if (!email.includes("@") || !email.includes(".")) {
    state.errorMsg = "Please enter a valid email address."; render(); return;
  }
  if (phone.length < 10) {
    state.errorMsg = "Please enter a valid phone number."; render(); return;
  }

  state.errorMsg = "";
  state.email = email;
  state.phone = phone;
  const btn = document.getElementById("startBtn");
  if (btn) { btn.disabled = true; btn.textContent = "Sending code..."; }

  try {
    await apiPost("/api/send-otp", { email, phone });
    state.otp = "";
    state.screen = "otp";
  } catch (e) {
    state.errorMsg = e.data && e.data.error ? e.data.error : "Could not send verification code. Try again.";
  }
  render();
};

window.resendOtp = async () => {
  state.errorMsg = "";
  const btn = document.getElementById("resendBtn");
  if (btn) { btn.disabled = true; btn.textContent = "Sending..."; }
  try {
    await apiPost("/api/send-otp", { email: state.email, phone: state.phone });
    state.errorMsg = "";
    const status = document.createElement("div");
    // show success via err slot in green? use sub - set a temp message
    state.errorMsg = "";
    if (btn) btn.textContent = "Code resent!";
    setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = "Resend Code"; } }, 2000);
  } catch (e) {
    state.errorMsg = e.data && e.data.error ? e.data.error : "Could not resend code.";
    render();
  }
};

window.submitOtp = async () => {
  const otp = (document.getElementById("otpInput").value || "").replace(/\D/g, "");
  if (otp.length < 4) {
    state.errorMsg = "Enter the verification code from your email."; render(); return;
  }

  state.errorMsg = "";
  state.otp = otp;
  const btn = document.getElementById("verifyBtn");
  if (btn) { btn.disabled = true; btn.textContent = "Verifying..."; }

  try {
    const record = await apiPost("/api/register", { email: state.email, phone: state.phone, otp });
    state.record = record;
    state.otp = "";

    if (record.prize_claimed) state.screen = "claimed";
    else if (openPrizeDecision(record, record)) state.screen = "decision";
    else if (record.locked) state.screen = "locked";
    else state.screen = "hub";
  } catch (e) {
    state.errorMsg = e.data && e.data.error ? e.data.error : "Verification failed. Please try again.";
  }
  render();
};

function renderHub() {
  const r = state.record;
  const upcoming = TIERS_DISPLAY.find(t => !(r.decided_tiers || []).includes(t.threshold));
  app.innerHTML = `
    <h1>Choose Your Game</h1>
    <div class="stats">
      <div>Points<b>${r.points}</b></div>
      <div>Plays Left<b>${playsLeftLabel(r)}</b></div>
      <div>Next Prize<b>${upcoming ? upcoming.threshold + " pts" : "—"}</b></div>
    </div>
    <div class="game-card" onclick="startTTT()">
      <div class="gtitle">⭕ Tic-Tac-Toe</div>
      <div class="gdesc">Outsmart the computer and earn points with every win.</div>
    </div>
    <div class="game-card" onclick="startMemory()">
      <div class="gtitle">🃏 Memory Match</div>
      <div class="gdesc">Match 6 product pairs in ${MM_TIME_LIMIT} seconds — new products every round!</div>
    </div>
    <div class="game-card" onclick="startFlappy()">
      <div class="gtitle">🦆 Flappy Duck</div>
      <div class="gdesc">Tap to fly through ${FLAPPY_PIPES_TO_WIN} pipes without crashing.</div>
    </div>
    <div class="game-card" onclick="startSnake()">
      <div class="gtitle">🐍 Snake</div>
      <div class="gdesc">Eat ${SNAKE_TARGET_SCORE} points of food in ${SNAKE_TIME_LIMIT_SEC} seconds. Swipe to steer.</div>
    </div>
    <div class="game-card" onclick="startWhack()">
      <div class="gtitle">✨ Zap the Dirt</div>
      <div class="gdesc">Tap ${WHACK_TARGET_HITS} dirt spots before the ${WHACK_TIME_LIMIT_SEC}s timer runs out.</div>
    </div>
  `;
}

function renderClaimed() {
  const r = state.record;
  const rr = state.redeemResult;
  const wr = state.wheelResult;
  const prize = (wr && (wr.prize || wr.wheel_prize)) || (rr && rr.prize) || r.won_prize || r.wheel_prize;
  const code = (wr && (wr.discount_code || wr.wheel_discount_code)) || (rr && rr.discount_code) || r.discount_code || r.wheel_discount_code;
  const checkoutUrl = (wr && wr.checkout_url) || (rr && rr.checkout_url) || r.checkout_url;
  const instructions = wr
    ? wr.instructions
    : (rr
      ? rr.instructions
      : (code
        ? `Use code <b>${code}</b> at checkout with the same email you played with.`
        : "Thanks for playing!"));

  app.innerHTML = `
    <h1>🏆 Congratulations!</h1>
    <div class="banner gold">
      You won <b>${prize || "a prize"}</b>!
      ${code ? `<div style="margin-top:10px;font-size:15px;letter-spacing:1px;">${code}</div>` : ""}
      <div style="margin-top:8px;font-size:13px;">${instructions}</div>
    </div>
    <div class="sub">A Shopify order appears only after you complete checkout (even if the total is free).</div>
    ${checkoutUrl
      ? `<button class="btn btn-primary" onclick="window.location.href='${checkoutUrl}'">Complete Free Checkout</button>`
      : ""}
  `;
}

function renderWheel() {
  const prizes = state.wheelPrizes || [];
  const n = Math.max(prizes.length, 1);
  const colors = ["#34d399", "#10b981", "#6ee7b7", "#059669", "#bbf7d0", "#065f46", "#a7f3d0", "#047857"];
  const stops = prizes.map((_, i) => {
    const start = (i / n) * 360;
    const end = ((i + 1) / n) * 360;
    return `${colors[i % colors.length]} ${start}deg ${end}deg`;
  }).join(", ");

  const labels = prizes.map((item, i) => {
    const angle = ((i + 0.5) / n) * 360;
    const name = typeof item === "string" ? item : (item.name || "");
    const image = typeof item === "string" ? "" : (item.image || "");
    const safeName = String(name).replace(/"/g, "&quot;");
    if (image) {
      return `<div class="wheel-label wheel-label-img" style="--a:${angle}deg" title="${safeName}">
        <img src="${image}" alt="${safeName}" loading="lazy" decoding="async">
      </div>`;
    }
    return `<div class="wheel-label" style="--a:${angle}deg" title="${safeName}"></div>`;
  }).join("");

  app.innerHTML = `
    <h1>🎡 Spin the Wheel</h1>
    <div class="sub">One spin for one free gift — whatever the wheel lands on is yours!</div>
    <div class="wheel-wrap">
      <div class="wheel-pointer"></div>
      <div class="wheel" id="bonusWheel" style="background: conic-gradient(${stops});">
        ${labels}
        <div class="wheel-hub">SPIN</div>
      </div>
    </div>
    <div class="status" id="wheelStatus">${state.wheelSpinning ? "Spinning..." : "Tap Spin to win your gift"}</div>
    <div class="err">${state.errorMsg || ""}</div>
    <button class="btn btn-primary" id="spinBtn" onclick="spinBonusWheel()" ${state.wheelSpinning ? "disabled" : ""}>
      ${state.wheelSpinning ? "Spinning..." : "Spin the Wheel"}
    </button>
    ${!state.wheelSpinning ? `<button class="btn btn-ghost" onclick="backToDecision()">Back to choices</button>` : ""}
  `;
}

window.spinBonusWheel = async () => {
  if (state.wheelSpinning) return;
  state.wheelSpinning = true;
  state.errorMsg = "";
  const btn = document.getElementById("spinBtn");
  const status = document.getElementById("wheelStatus");
  if (btn) { btn.disabled = true; btn.textContent = "Spinning..."; }
  if (status) status.textContent = "Spinning...";

  try {
    const result = await apiPost("/api/spin-wheel", {
      email: state.email,
      threshold: state.pendingTier
    });
    state.wheelResult = result;
    state.redeemResult = {
      prize: result.prize || result.wheel_prize,
      discount_code: result.discount_code || result.wheel_discount_code,
      checkout_url: result.checkout_url,
      instructions: result.instructions
    };
    if (state.record) {
      state.record.prize_claimed = true;
      state.record.won_prize = result.prize || result.wheel_prize;
      state.record.discount_code = result.discount_code || result.wheel_discount_code;
      state.record.wheel_spun = true;
      state.record.wheel_prize = result.wheel_prize;
      state.record.wheel_discount_code = result.wheel_discount_code || result.discount_code;
      state.record.checkout_url = result.checkout_url;
      state.record.points = 0;
    }
    state.pendingTier = null;

    const wheel = document.getElementById("bonusWheel");
    const n = (result.wheel_prizes || state.wheelPrizes || []).length || 8;
    const index = result.index ?? 0;
    const segmentCenter = ((index + 0.5) / n) * 360;
    const finalRotation = 360 * 6 + (360 - segmentCenter);
    if (wheel) {
      wheel.style.transition = "transform 4.2s cubic-bezier(0.12, 0.75, 0.12, 1)";
      wheel.style.transform = `rotate(${finalRotation}deg)`;
    }
    if (status) status.textContent = "Landing on " + result.wheel_prize + "...";

    setTimeout(() => {
      state.wheelSpinning = false;
      state.screen = "claimed";
      render();
    }, 4500);
  } catch (e) {
    state.wheelSpinning = false;
    if (e.status === 409 && e.data) {
      state.wheelResult = e.data;
      state.screen = "claimed";
    } else {
      state.errorMsg = e.data && e.data.error ? e.data.error : "Could not spin. Try again.";
    }
    render();
  }
};

function renderLocked() {
  // If they already earned a prize unlock, show that instead of waiting out the timer
  if (openPrizeDecision(state.record)) {
    render();
    return;
  }
  app.innerHTML = `
    <h1>⏳ Take a short break</h1>
    <div class="sub">You've used all ${MAX_PLAYS_PER_WINDOW} plays. Come back in ${cooldownLabel()}.</div>
    <div class="lock-timer" id="lockTimer">${timeRemaining(state.record)}</div>
    <div class="footer-note">Your next play unlocks when the timer reaches zero.</div>
  `;
  clearInterval(window._lockInterval);
  window._lockInterval = setInterval(() => {
    if (state.screen === "locked") {
      const el = document.getElementById("lockTimer");
      if (el) el.textContent = timeRemaining(state.record);
      if (!isLocked(state.record)) {
        clearInterval(window._lockInterval);
        if (openPrizeDecision(state.record)) render();
        else {
          state.screen = "hub";
          render();
        }
      }
    }
  }, 1000);
}

window.startTTT = () => {
  if (guardLocked()) return;
  stopAllGameLoops();
  state.currentGame = "ttt";
  state.board = Array(9).fill(null);
  state.turn = "player";
  state.over = false;
  state.resultMsg = "";
  state.screen = "ttt";
  render();
};

function renderTTT() {
  const r = state.record;

  app.innerHTML = `
    <h1>⭕ Tic-Tac-Toe</h1>
    <div class="stats">
      <div>Points<b>${r.points}</b></div>
      <div>Plays Left<b>${playsLeftLabel(r)}</b></div>
      <div>Status<b>Playing</b></div>
    </div>
    <div class="status">${state.resultMsg || (state.turn === "player" ? "Your turn (X)" : "Computer thinking...")}</div>
    <div class="board" id="board"></div>
    ${state.over
      ? `<button class="btn btn-primary" onclick="playAgain()">Play Again</button><button class="btn btn-ghost" onclick="backToHub()">Choose Different Game</button>`
      : `<button class="btn btn-ghost" onclick="backToHub()">Back to Games</button>`}
  `;

  const boardEl = document.getElementById("board");
  state.board.forEach((val, i) => {
    const btn = document.createElement("button");
    btn.className = "cell" + (val === "O" ? " o" : "");
    btn.textContent = val || "";
    btn.disabled = !!val || state.over || state.turn !== "player";
    btn.onclick = () => playerMove(i);
    boardEl.appendChild(btn);
  });
}

window.backToHub = () => {
  stopAllGameLoops();
  const r = state.record;
  if (r.prize_claimed) state.screen = "claimed";
  else if (isLocked(r)) state.screen = "locked";
  else state.screen = "hub";
  render();
};

async function playerMove(i) {
  if (state.board[i] || state.over || state.turn !== "player") return;
  state.board[i] = "X";
  const w = winner(state.board);
  if (w) { return endGame(w); }
  state.turn = "computer";
  render();
  setTimeout(async () => {
    const move = computerMove(state.board);
    state.board[move] = "O";
    const w2 = winner(state.board);
    if (w2) { return endGame(w2); }
    state.turn = "player";
    render();
  }, 500);
}

async function endGame(result) {
  state.over = true;
  const apiResult = result === "X" ? "win" : (result === "draw" ? "draw" : "lose");

  if (result === "X") state.resultMsg = "🎉 You won! +" + WIN_POINTS + " points";
  else if (result === "O") {
    const loseMsgs = {
      memory: "Time's up! Try again.",
      flappy: "Crashed! Try again.",
      snake: state.snake && state.snake.loseReason === "time" ? "Time's up! Try again." : "Crashed! Try again.",
      whack: "Time's up! Try again.",
      ttt: "Computer won this round. Try again!"
    };
    state.resultMsg = loseMsgs[state.currentGame] || "Try again!";
  }
  else state.resultMsg = "It's a draw!";

  render();

  try {
    const data = await apiPost("/api/play-result", { email: state.email, result: apiResult });
    state.record = data;

    // Prize unlock must win over the play-limit "short break" screen
    if (data.reached_tier || findPendingTier(data)) {
      openPrizeDecision(data, data);
      render();
      setTimeout(() => { state.screen = "decision"; render(); }, 900);
      return;
    }

    if (data.locked) {
      state.screen = "locked";
      render();
      return;
    }
  } catch (e) {
    if (handlePlayLimitError(e)) return;
    state.resultMsg = "Could not save your result — check your connection.";
  }

  render();
}

function renderDecision() {
  const threshold = state.pendingTier;
  const pool = state.pendingTierPool || [];
  const items = state.pendingTierItems || pool.map(name => ({ name }));
  const tierIndex = TIERS_DISPLAY.findIndex(t => t.threshold === threshold);
  const nextTier = TIERS_DISPLAY[tierIndex + 1];

  if (state.decisionMode === "pick") {
    const pickButtons = items.map((item) => {
      const name = typeof item === "string" ? item : item.name;
      const safe = String(name).replace(/'/g, "\\'");
      return `<button class="btn btn-ghost prize-pick-btn" onclick="redeemPrize('${safe}')">${name}</button>`;
    }).join("");

    app.innerHTML = `
      <h1>🎁 Pick Your Gift</h1>
      <div class="sub">Choose <b>one</b> prize from the ${threshold}-point list.</div>
      <div class="prize-pick-list">${pickButtons}</div>
      <div class="err">${state.errorMsg || ""}</div>
      <button class="btn btn-ghost" onclick="backToDecision()">Back to choices</button>
    `;
    return;
  }

  app.innerHTML = `
    <h1>🏆 ${threshold} Points!</h1>
    <div class="banner gold">
      You've unlocked a free gift. Choose <b>one</b> option below — you only get one gift.
    </div>
    <button class="btn btn-primary" onclick="chooseSpinWheel()">🎡 Spin the Wheel</button>
    <div class="sub" style="margin:6px 0 2px;">Surprise gift — whatever the wheel lands on.</div>
    <button class="btn btn-primary" onclick="choosePickGift()">🎁 Pick a Gift</button>
    <div class="sub" style="margin:6px 0 10px;">Choose any prize from: <b>${pool.join(" · ")}</b></div>
    ${nextTier
      ? `<div class="banner">Or keep playing for <b>${nextTier.threshold} pts</b> — bigger prizes.</div>
         <button class="btn btn-ghost" onclick="continuePlaying()">Keep Playing</button>`
      : `<div class="banner">You've reached the top tier — claim your gift now.</div>`}
    <div class="err">${state.errorMsg || ""}</div>
  `;
}

window.chooseSpinWheel = () => {
  state.errorMsg = "";
  state.decisionMode = null;
  state.screen = "wheel";
  render();
};

window.choosePickGift = () => {
  state.errorMsg = "";
  state.decisionMode = "pick";
  render();
};

window.backToDecision = () => {
  if (state.wheelSpinning) return;
  state.errorMsg = "";
  state.decisionMode = null;
  state.screen = "decision";
  render();
};

window.redeemPrize = async (prizeName) => {
  if (!prizeName) {
    state.errorMsg = "Please choose a prize.";
    state.decisionMode = "pick";
    render();
    return;
  }
  const buttons = document.querySelectorAll(".prize-pick-btn");
  buttons.forEach(b => { b.disabled = true; });
  try {
    const result = await apiPost("/api/redeem", {
      email: state.email,
      threshold: state.pendingTier,
      prize_name: prizeName
    });
    state.redeemResult = result;
    state.wheelResult = null;
    state.record.prize_claimed = true;
    state.record.won_prize = result.prize;
    state.record.discount_code = result.discount_code;
    state.record.checkout_url = result.checkout_url;
    state.record.points = 0;
    state.record.wheel_spun = true;
    state.pendingTier = null;
    state.decisionMode = null;
    state.screen = "claimed";
  } catch (e) {
    state.errorMsg = e.data && e.data.error ? e.data.error : "Could not generate your prize code.";
    state.decisionMode = "pick";
    state.screen = "decision";
  }
  render();
};

window.continuePlaying = async () => {
  try {
    const data = await apiPost("/api/continue-playing", { email: state.email, threshold: state.pendingTier });
    state.record = data;
  } catch (e) { /* non-fatal */ }
  state.pendingTier = null;
  state.screen = isLocked(state.record) ? "locked" : "hub";
  render();
};

window.playAgain = () => {
  if (guardLocked()) return;
  if (state.currentGame === "ttt") startTTT();
  else if (state.currentGame === "flappy") startFlappy();
  else if (state.currentGame === "snake") startSnake();
  else if (state.currentGame === "whack") startWhack();
  else startMemory();
};

function mmCardHtml(card) {
  const label = String(card.product.label).replace(/"/g, "&quot;");
  return `
    <span class="mm-face mm-face-back" aria-hidden="true">?</span>
    <span class="mm-face mm-face-front">
      <span class="mm-emoji">${card.product.emoji}</span>
      <span class="mm-label">${label}</span>
    </span>`;
}

function mmUnlockBoard(mm) {
  if (!mm) return;
  mm.busy = false;
  mm.flippedIds = [];
  const grid = document.getElementById("mmGrid");
  if (grid) grid.classList.remove("mm-busy");
}

function mmSyncCard(btn, card) {
  btn.classList.toggle("flipped", !!card.flipped && !card.matched);
  btn.classList.toggle("matched", !!card.matched);
  btn.setAttribute("aria-label", (card.flipped || card.matched) ? card.product.label : "Hidden card");
}

function mmSyncBoard() {
  const mm = state.mm;
  const grid = document.getElementById("mmGrid");
  if (!mm || !grid) return;

  grid.classList.toggle("mm-busy", !!mm.busy);
  const pairsEl = document.getElementById("mmPairs");
  if (pairsEl) pairsEl.textContent = `${mm.matchedCount}/${mm.totalPairs}`;

  const buttons = grid.querySelectorAll(".mm-card");
  mm.cards.forEach((card, i) => {
    if (buttons[i]) mmSyncCard(buttons[i], card);
  });
}

function mmHandleGridTap(e) {
  if (e.pointerType === "mouse" && e.button !== 0) return;
  const btn = e.target.closest(".mm-card");
  if (!btn || btn.classList.contains("matched")) return;
  if (!state.mm || state.mm.busy || state.over || state.screen !== "memory") return;
  const id = Number(btn.dataset.id);
  if (Number.isNaN(id)) return;
  e.preventDefault();
  mmFlip(id);
}

window.startMemory = () => {
  if (guardLocked()) return;
  stopAllGameLoops();
  state.currentGame = "memory";
  state.over = false;
  state.resultMsg = "";
  state.mm = {
    cards: buildMemoryDeck(),
    flippedIds: [],
    matchedCount: 0,
    timeLeft: MM_TIME_LIMIT,
    busy: false,
    totalPairs: MM_PAIR_COUNT,
    roundId: Date.now()
  };
  state.screen = "memory";
  render();

  clearInterval(window._mmInterval);
  window._mmInterval = setInterval(() => {
    if (state.screen !== "memory" || state.over || !state.mm) {
      clearInterval(window._mmInterval);
      return;
    }
    state.mm.timeLeft -= 1;
    if (state.mm.timeLeft <= 0) {
      clearInterval(window._mmInterval);
      state.mm.timeLeft = 0;
      mmUnlockBoard(state.mm);
      endGame("O");
      return;
    }
    const timerEl = document.getElementById("mmTimer");
    if (timerEl) {
      timerEl.textContent = state.mm.timeLeft + "s";
      timerEl.classList.toggle("urgent", state.mm.timeLeft <= 10);
    }
  }, 1000);
};

function renderMemory() {
  const r = state.record;
  const mm = state.mm;
  const urgentClass = mm.timeLeft <= 10 ? " urgent" : "";

  app.innerHTML = `
    <h1>🃏 Memory Match</h1>
    <div class="stats">
      <div>Points<b>${r.points}</b></div>
      <div>Plays Left<b>${playsLeftLabel(r)}</b></div>
      <div>Pairs<b id="mmPairs">${mm.matchedCount}/${mm.totalPairs}</b></div>
    </div>
    <div class="mm-timer${urgentClass}" id="mmTimer">${mm.timeLeft}s</div>
    <div class="status">${state.resultMsg || `Match ${mm.totalPairs} product pairs in ${MM_TIME_LIMIT} seconds`}</div>
    <div class="mm-grid${mm.busy ? " mm-busy" : ""}" id="mmGrid"></div>
    ${state.over
      ? `<button class="btn btn-primary" onclick="playAgain()">Play Again</button><button class="btn btn-ghost" onclick="backToHub()">Choose Different Game</button>`
      : `<button class="btn btn-ghost" onclick="backToHub()">Back to Games</button>`}
  `;

  const grid = document.getElementById("mmGrid");
  grid.addEventListener("pointerdown", mmHandleGridTap);

  mm.cards.forEach(c => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mm-card";
    btn.dataset.id = String(c.id);
    btn.innerHTML = mmCardHtml(c);
    mmSyncCard(btn, c);
    grid.appendChild(btn);
  });
}

function mmSchedule(fn, ms) {
  if (!window._mmFlipTimers) window._mmFlipTimers = [];
  const timer = setTimeout(() => {
    window._mmFlipTimers = (window._mmFlipTimers || []).filter(t => t !== timer);
    fn();
  }, ms);
  window._mmFlipTimers.push(timer);
}

function mmFlip(id) {
  const mm = state.mm;
  if (!mm || mm.busy || state.over || state.screen !== "memory") return;
  const card = mm.cards.find(c => c.id === id);
  if (!card || card.flipped || card.matched) return;

  const roundId = mm.roundId;
  card.flipped = true;
  mm.flippedIds.push(id);
  mmSyncBoard();

  if (mm.flippedIds.length < 2) return;

  mm.busy = true;
  const grid = document.getElementById("mmGrid");
  if (grid) grid.classList.add("mm-busy");

  const [id1, id2] = mm.flippedIds;
  const c1 = mm.cards.find(c => c.id === id1);
  const c2 = mm.cards.find(c => c.id === id2);
  const isMatch = c1.key === c2.key;

  mmSchedule(() => {
    if (!state.mm || state.mm.roundId !== roundId || state.screen !== "memory") return;

    if (isMatch) {
      c1.matched = true;
      c2.matched = true;
      c1.flipped = true;
      c2.flipped = true;
      mm.matchedCount += 1;
      mmUnlockBoard(mm);
      mmSyncBoard();

      if (mm.matchedCount === mm.totalPairs) {
        clearInterval(window._mmInterval);
        endGame("X");
      }
      return;
    }

    c1.flipped = false;
    c2.flipped = false;
    mmUnlockBoard(mm);
    mmSyncBoard();
  }, isMatch ? 380 : 720);
}

function gameStatsHtml(thirdLabel, thirdValue) {
  const r = state.record;
  return `
    <div class="stats">
      <div>Points<b>${r.points}</b></div>
      <div>Plays Left<b>${playsLeftLabel(r)}</b></div>
      <div>${thirdLabel}<b>${thirdValue}</b></div>
    </div>`;
}

function prizeBannerHtml() {
  return "";
}

function roundButtonsHtml() {
  return state.over
    ? `<button class="btn btn-primary" onclick="playAgain()">Play Again</button><button class="btn btn-ghost" onclick="backToHub()">Choose Different Game</button>`
    : `<button class="btn btn-ghost" onclick="backToHub()">Back to Games</button>`;
}

function finishRound(result) {
  if (state.over) return;
  state.over = true;
  stopAllGameLoops();
  endGame(result);
}

function wrapCss(name) {
  const el = document.querySelector(".pw-wrap");
  if (!el) return "";
  return getComputedStyle(el).getPropertyValue(name).trim();
}

window.startFlappy = () => {
  if (guardLocked()) return;
  stopAllGameLoops();
  state.currentGame = "flappy";
  state.over = false;
  state.resultMsg = "";
  state.flappy = {
    y: 0,
    vy: 0,
    pipes: [],
    passed: 0,
    started: false,
    w: 0,
    h: 0
  };
  state.screen = "flappy";
  render();
  requestAnimationFrame(() => startFlappyLoop());
};

function renderFlappy() {
  const f = state.flappy;
  const passed = f ? f.passed : 0;
  app.innerHTML = `
    <h1>🦆 Flappy Duck</h1>
    ${gameStatsHtml("Pipes", passed + "/" + FLAPPY_PIPES_TO_WIN)}
    ${prizeBannerHtml()}
    <div class="status">${state.resultMsg || (state.over ? "" : "Tap the sky or Flap to fly. Pass " + FLAPPY_PIPES_TO_WIN + " pipes.")}</div>
    ${state.over ? "" : `
      <div class="flappy-stage" id="flappyStage">
        <canvas id="flappyCanvas"></canvas>
      </div>
      <button class="btn btn-primary" type="button" id="flapBtn">Flap</button>
    `}
    ${roundButtonsHtml()}
  `;
  if (!state.over) bindFlappyInput();
}

function bindFlappyInput() {
  const stage = document.getElementById("flappyStage");
  const btn = document.getElementById("flapBtn");
  const flap = (e) => {
    if (e) e.preventDefault();
    flappyFlap();
  };
  if (stage) {
    stage.addEventListener("pointerdown", flap);
  }
  if (btn) {
    btn.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      e.stopPropagation();
      flappyFlap();
    });
  }
}

function flappyFlap() {
  if (state.over || state.screen !== "flappy" || !state.flappy) return;
  const f = state.flappy;
  if (!f.started) f.started = true;
  f.vy = FLAPPY_FLAP_STRENGTH;
}

function sizeFlappyCanvas(canvas) {
  const w = canvas.clientWidth || 320;
  const h = canvas.clientHeight || 280;
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const tw = Math.round(w * dpr);
  const th = Math.round(h * dpr);
  if (canvas.width !== tw || canvas.height !== th) {
    canvas.width = tw;
    canvas.height = th;
  }
  const ctx = canvas.getContext("2d");
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  return { ctx, w, h };
}

function startFlappyLoop() {
  const canvas = document.getElementById("flappyCanvas");
  if (!canvas || !state.flappy) return;
  const sized = sizeFlappyCanvas(canvas);
  const f = state.flappy;
  f.w = sized.w;
  f.h = sized.h;
  f.y = sized.h * 0.42;
  f.vy = 0;
  f.pipes = [{ x: sized.w + 40, gapY: flappyGapY(sized.h) }];
  f.passed = 0;
  f.started = false;
  const duckX = 64;

  const tick = () => {
    if (state.screen !== "flappy" || state.over) return;
    const live = document.getElementById("flappyCanvas");
    if (!live) return;
    const { ctx, w, h } = sizeFlappyCanvas(live);
    f.w = w;
    f.h = h;
    const gap = Math.min(FLAPPY_PIPE_GAP, h - 80);
    const duck = FLAPPY_DUCK_SIZE;

    if (f.started) {
      f.vy += FLAPPY_GRAVITY;
      if (f.vy > 10) f.vy = 10;
      f.y += f.vy;

      for (const p of f.pipes) p.x -= FLAPPY_PIPE_SPEED;
      const last = f.pipes[f.pipes.length - 1];
      if (last && last.x < w - FLAPPY_PIPE_SPACING) {
        f.pipes.push({ x: w + 10, gapY: flappyGapY(h) });
      }
      f.pipes = f.pipes.filter(p => p.x + FLAPPY_PIPE_WIDTH > -20);

      const hitPad = 4;
      const duckBox = { x: duckX + hitPad, y: f.y + hitPad, w: duck - hitPad * 2, h: duck - hitPad * 2 };
      if (f.y <= 0 || f.y + duck >= h) {
        finishRound("O");
        return;
      }
      for (const p of f.pipes) {
        const top = { x: p.x, y: 0, w: FLAPPY_PIPE_WIDTH, h: p.gapY };
        const bot = { x: p.x, y: p.gapY + gap, w: FLAPPY_PIPE_WIDTH, h: h - (p.gapY + gap) };
        if (rectsOverlap(duckBox, top) || rectsOverlap(duckBox, bot)) {
          finishRound("O");
          return;
        }
        if (!p.counted && p.x + FLAPPY_PIPE_WIDTH < duckX) {
          p.counted = true;
          f.passed += 1;
          const el = document.getElementById("flappyCount");
          if (el) el.textContent = f.passed + "/" + FLAPPY_PIPES_TO_WIN;
          const statB = document.querySelector("#app .stats div:last-child b");
          if (statB) statB.textContent = f.passed + "/" + FLAPPY_PIPES_TO_WIN;
          if (f.passed >= FLAPPY_PIPES_TO_WIN) {
            f.pipes = f.pipes.filter(pipe => pipe.counted);
            finishRound("X");
            return;
          }
        }
      }
    } else {
      f.y = h * 0.42 + Math.sin(Date.now() / 220) * 6;
    }

    drawFlappy(ctx, w, h, f, duckX, gap, duck);
    window._flappyRaf = requestAnimationFrame(tick);
  };
  window._flappyRaf = requestAnimationFrame(tick);
}

function flappyGapY(h) {
  const gap = Math.min(FLAPPY_PIPE_GAP, h - 80);
  const pad = 28;
  const maxY = h - gap - pad;
  return pad + Math.random() * Math.max(8, maxY - pad);
}

function rectsOverlap(a, b) {
  return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
}

function drawFlappy(ctx, w, h, f, duckX, gap, duck) {
  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = wrapCss("--accent-soft") || "#bbf7d0";
  ctx.fillRect(0, 0, w, h);
  const pipeFill = wrapCss("--accent") || "#10b981";
  const pipeEdge = wrapCss("--accent-dark") || "#065f46";
  for (const p of f.pipes) {
    ctx.fillStyle = pipeFill;
    ctx.fillRect(p.x, 0, FLAPPY_PIPE_WIDTH, p.gapY);
    ctx.fillRect(p.x, p.gapY + gap, FLAPPY_PIPE_WIDTH, h - (p.gapY + gap));
    ctx.fillStyle = pipeEdge;
    ctx.fillRect(p.x, p.gapY - 12, FLAPPY_PIPE_WIDTH, 12);
    ctx.fillRect(p.x, p.gapY + gap, FLAPPY_PIPE_WIDTH, 12);
  }
  ctx.font = `${duck}px "Segoe UI Emoji", "Apple Color Emoji", sans-serif`;
  ctx.textBaseline = "top";
  ctx.save();
  ctx.translate(duckX + duck, f.y);
  ctx.scale(-1, 1);
  ctx.fillText("🦆", 0, 0);
  ctx.restore();
}

window.startSnake = () => {
  if (guardLocked()) return;
  stopAllGameLoops();
  state.currentGame = "snake";
  state.over = false;
  state.resultMsg = "";
  const mid = Math.floor(SNAKE_GRID_SIZE / 2);
  state.snake = {
    body: [{ x: 3, y: mid }, { x: 2, y: mid }, { x: 1, y: mid }],
    dir: "right",
    pendingDir: "right",
    food: null,
    bonus: null,
    score: 0,
    timeLeft: SNAKE_TIME_LIMIT_SEC,
    loseReason: ""
  };
  state.snake.food = snakeRandomEmpty();
  state.screen = "snake";
  render();
  bindSnakeInput();
  window._snakeTick = setInterval(snakeTick, SNAKE_TICK_MS);
  window._snakeClock = setInterval(() => {
    if (state.screen !== "snake" || state.over) return;
    state.snake.timeLeft -= 1;
    const el = document.getElementById("snakeTimer");
    if (el) {
      el.textContent = state.snake.timeLeft + "s";
      el.classList.toggle("urgent", state.snake.timeLeft <= 10);
    }
    if (state.snake.timeLeft <= 0) {
      state.snake.timeLeft = 0;
      state.snake.loseReason = "time";
      finishRound("O");
    }
  }, 1000);
};

function renderSnake() {
  const sn = state.snake;
  const score = sn ? sn.score : 0;
  const timeLeft = sn ? sn.timeLeft : SNAKE_TIME_LIMIT_SEC;
  const urgent = timeLeft <= 10 ? " urgent" : "";
  app.innerHTML = `
    <h1>🐍 Snake</h1>
    ${gameStatsHtml("Score", score + "/" + SNAKE_TARGET_SCORE)}
    ${prizeBannerHtml()}
    <div class="mm-timer${urgent}" id="snakeTimer">${timeLeft}s</div>
    <div class="status">${state.resultMsg || (state.over ? "" : "Swipe the board or tap the arrows. Eat " + SNAKE_TARGET_SCORE + " points.")}</div>
    <div class="snake-touch" id="snakeTouch">
      <div class="snake-grid" id="snakeGrid"></div>
    </div>
    ${state.over ? "" : `
      <div class="snake-pad" id="snakePad">
        <button type="button" class="snake-pad-btn" data-dir="up" aria-label="Up">▲</button>
        <div class="snake-pad-row">
          <button type="button" class="snake-pad-btn" data-dir="left" aria-label="Left">◀</button>
          <button type="button" class="snake-pad-btn" data-dir="down" aria-label="Down">▼</button>
          <button type="button" class="snake-pad-btn" data-dir="right" aria-label="Right">▶</button>
        </div>
      </div>
    `}
    ${roundButtonsHtml()}
  `;
  paintSnakeGrid();
  if (!state.over) bindSnakeInput();
}

function snakeKey(cell) {
  return cell.x + "," + cell.y;
}

function snakeRandomEmpty() {
  const blocked = new Set(state.snake.body.map(snakeKey));
  if (state.snake.food) blocked.add(snakeKey(state.snake.food));
  if (state.snake.bonus) blocked.add(snakeKey(state.snake.bonus));
  const open = [];
  for (let y = 0; y < SNAKE_GRID_SIZE; y++) {
    for (let x = 0; x < SNAKE_GRID_SIZE; x++) {
      if (!blocked.has(x + "," + y)) open.push({ x, y });
    }
  }
  if (!open.length) return null;
  return open[Math.floor(Math.random() * open.length)];
}

function snakeSetDir(next) {
  const sn = state.snake;
  if (!sn || state.over) return;
  const current = sn.pendingDir || sn.dir;
  const opp = { left: "right", right: "left", up: "down", down: "up" };
  if (opp[next] === current) return;
  sn.pendingDir = next;
}

function bindSnakeInput() {
  const zone = document.getElementById("snakeTouch") || document.getElementById("snakeGrid");
  const pad = document.getElementById("snakePad");
  if (!zone || zone.dataset.bound) return;
  zone.dataset.bound = "1";

  let sx = 0;
  let sy = 0;
  let tracking = false;

  const applySwipe = (x, y) => {
    if (!tracking) return;
    tracking = false;
    const dx = x - sx;
    const dy = y - sy;
    if (Math.abs(dx) < 12 && Math.abs(dy) < 12) return;
    if (Math.abs(dx) > Math.abs(dy)) snakeSetDir(dx > 0 ? "right" : "left");
    else snakeSetDir(dy > 0 ? "down" : "up");
  };

  zone.addEventListener("pointerdown", (e) => {
    tracking = true;
    sx = e.clientX;
    sy = e.clientY;
    try { zone.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
  });
  zone.addEventListener("pointerup", (e) => applySwipe(e.clientX, e.clientY));
  zone.addEventListener("pointercancel", () => { tracking = false; });
  zone.addEventListener("touchmove", (e) => {
    if (tracking) e.preventDefault();
  }, { passive: false });

  if (pad) {
    pad.querySelectorAll("[data-dir]").forEach((btn) => {
      const go = (e) => {
        e.preventDefault();
        e.stopPropagation();
        snakeSetDir(btn.getAttribute("data-dir"));
      };
      btn.addEventListener("pointerdown", go);
    });
  }

  window._snakeKeyHandler = (e) => {
    const map = { ArrowLeft: "left", ArrowRight: "right", ArrowUp: "up", ArrowDown: "down" };
    if (!map[e.key]) return;
    e.preventDefault();
    snakeSetDir(map[e.key]);
  };
  window.addEventListener("keydown", window._snakeKeyHandler);
}

function snakeTick() {
  if (state.screen !== "snake" || state.over || !state.snake) return;
  const sn = state.snake;
  sn.dir = sn.pendingDir;
  const head = sn.body[0];
  const step = { left: [-1, 0], right: [1, 0], up: [0, -1], down: [0, 1] }[sn.dir];
  const next = { x: head.x + step[0], y: head.y + step[1] };
  if (next.x < 0 || next.y < 0 || next.x >= SNAKE_GRID_SIZE || next.y >= SNAKE_GRID_SIZE) {
    sn.loseReason = "crash";
    finishRound("O");
    return;
  }
  if (sn.body.some(seg => seg.x === next.x && seg.y === next.y)) {
    sn.loseReason = "crash";
    finishRound("O");
    return;
  }
  sn.body.unshift(next);
  let grew = false;
  if (sn.food && next.x === sn.food.x && next.y === sn.food.y) {
    sn.score += 1;
    grew = true;
    sn.food = snakeRandomEmpty();
  } else if (sn.bonus && next.x === sn.bonus.x && next.y === sn.bonus.y) {
    sn.score += 3;
    grew = true;
    sn.bonus = null;
  }
  if (!grew) sn.body.pop();

  if (sn.bonus && Date.now() >= sn.bonus.expiresAt) sn.bonus = null;
  if (!sn.bonus && Math.random() < SNAKE_BONUS_FOOD_CHANCE) {
    const cell = snakeRandomEmpty();
    if (cell) sn.bonus = { x: cell.x, y: cell.y, expiresAt: Date.now() + SNAKE_BONUS_FOOD_LIFESPAN_SEC * 1000 };
  }

  const scoreEl = document.querySelector("#app .stats div:last-child b");
  if (scoreEl) scoreEl.textContent = sn.score + "/" + SNAKE_TARGET_SCORE;
  paintSnakeGrid();

  if (sn.score >= SNAKE_TARGET_SCORE) {
    finishRound("X");
  }
}

function paintSnakeGrid() {
  const grid = document.getElementById("snakeGrid");
  const sn = state.snake;
  if (!grid || !sn) return;
  grid.style.gridTemplateColumns = `repeat(${SNAKE_GRID_SIZE}, 1fr)`;
  const kind = {};
  sn.body.forEach((seg, i) => { kind[snakeKey(seg)] = i === 0 ? "head" : "body"; });
  if (sn.food) kind[snakeKey(sn.food)] = "food";
  if (sn.bonus) kind[snakeKey(sn.bonus)] = "bonus";
  let html = "";
  for (let y = 0; y < SNAKE_GRID_SIZE; y++) {
    for (let x = 0; x < SNAKE_GRID_SIZE; x++) {
      const k = kind[x + "," + y] || "";
      const glyph = k === "head" ? "●" : k === "body" ? "•" : k === "food" ? "🟢" : k === "bonus" ? "⭐" : "";
      html += `<div class="snake-cell${k ? " is-" + k : ""}">${glyph}</div>`;
    }
  }
  grid.innerHTML = html;
}

window.startWhack = () => {
  if (guardLocked()) return;
  stopAllGameLoops();
  state.currentGame = "whack";
  state.over = false;
  state.resultMsg = "";
  state.whack = {
    hits: 0,
    timeLeft: WHACK_TIME_LIMIT_SEC,
    active: Array(WHACK_GRID_SIZE).fill(false)
  };
  window._whackHideTimers = [];
  state.screen = "whack";
  render();
  window._whackSpawn = setInterval(whackSpawn, WHACK_SPAWN_INTERVAL_MS);
  window._whackClock = setInterval(() => {
    if (state.screen !== "whack" || state.over) return;
    state.whack.timeLeft -= 1;
    const el = document.getElementById("whackTimer");
    if (el) {
      el.textContent = state.whack.timeLeft + "s";
      el.classList.toggle("urgent", state.whack.timeLeft <= 5);
    }
    if (state.whack.timeLeft <= 0) {
      state.whack.timeLeft = 0;
      finishRound("O");
    }
  }, 1000);
};

function renderWhack() {
  const w = state.whack;
  const hits = w ? w.hits : 0;
  const timeLeft = w ? w.timeLeft : WHACK_TIME_LIMIT_SEC;
  const urgent = timeLeft <= 5 ? " urgent" : "";
  app.innerHTML = `
    <h1>✨ Zap the Dirt</h1>
    ${gameStatsHtml("Hits", hits + "/" + WHACK_TARGET_HITS)}
    ${prizeBannerHtml()}
    <div class="mm-timer${urgent}" id="whackTimer">${timeLeft}s</div>
    <div class="status">${state.resultMsg || (state.over ? "" : "Tap the dirt spots. Hit " + WHACK_TARGET_HITS + " before time runs out.")}</div>
    <div class="whack-grid" id="whackGrid"></div>
    ${roundButtonsHtml()}
  `;
  paintWhackGrid();
}

function paintWhackGrid() {
  const grid = document.getElementById("whackGrid");
  const w = state.whack;
  if (!grid || !w) return;
  grid.innerHTML = "";
  for (let i = 0; i < WHACK_GRID_SIZE; i++) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "whack-hole" + (w.active[i] ? " is-up" : "");
    btn.innerHTML = w.active[i] ? `<span class="whack-dirt">🟤</span>` : "";
    btn.disabled = state.over;
    btn.onclick = () => whackHit(i);
    grid.appendChild(btn);
  }
}

function paintWhackHole(i) {
  const grid = document.getElementById("whackGrid");
  if (!grid) return;
  const btn = grid.children[i];
  const w = state.whack;
  if (!btn || !w) return;
  btn.className = "whack-hole" + (w.active[i] ? " is-up" : "");
  btn.innerHTML = w.active[i] ? `<span class="whack-dirt">🟤</span>` : "";
}

function whackSpawn() {
  if (state.screen !== "whack" || state.over || !state.whack) return;
  const spawnOne = () => {
    const empty = [];
    for (let i = 0; i < WHACK_GRID_SIZE; i++) if (!state.whack.active[i]) empty.push(i);
    if (!empty.length) return;
    const idx = empty[Math.floor(Math.random() * empty.length)];
    state.whack.active[idx] = true;
    paintWhackHole(idx);
    const t = setTimeout(() => {
      if (!state.whack || state.over) return;
      state.whack.active[idx] = false;
      paintWhackHole(idx);
    }, WHACK_SPOT_VISIBLE_MS);
    window._whackHideTimers.push(t);
  };
  spawnOne();
  if (Math.random() < WHACK_DOUBLE_SPAWN_CHANCE) spawnOne();
}

function whackHit(i) {
  if (state.over || !state.whack || !state.whack.active[i]) return;
  state.whack.active[i] = false;
  state.whack.hits += 1;
  paintWhackHole(i);
  const scoreEl = document.querySelector("#app .stats div:last-child b");
  if (scoreEl) scoreEl.textContent = state.whack.hits + "/" + WHACK_TARGET_HITS;
  if (state.whack.hits >= WHACK_TARGET_HITS) finishRound("X");
}

loadGameConfig().then(() => render());

